export default function getProfile() {
  return window.auth.profile;
}
